var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResizeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  fillRule: "evenodd",
  d: "M4 22q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 20V4q0-.824.587-1.413A1.93 1.93 0 0 1 4 2h16q.824 0 1.413.587.586.589.587 1.413v16q0 .824-.587 1.413A1.93 1.93 0 0 1 20 22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  fillRule: "evenodd",
  d: "M4 20h16V4H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M16 8h-2.5V6H18v12h-4.5v-2H16zM6 6h4.5v2H8v8h2.5v2H6z"
}))));
export default SvgResizeIcon;